import { IpropsModalSettings } from "types/modal/TypeModal";
import OverlayModalCommon from "utils/settingsModal/common/OverLayModalCommon";
import LoadingLottie from "components/lottieLoading/LoadingLottie";
import { FC } from "react";

import {
  useSessionsListQuery,
  useSessionsDeleteAllMutation,
  useSessionsDeleteMutation,
} from "redux/RTQ/IlenkradApi";
import DeviceDetector from "device-detector-js";
import getUserLocale from "../getUserLocale";
import { useNavigate } from "react-router-dom";
import LoadingLottiePc from "components/lottieLoading/LoadingLottiePc";

const SessionModalPc: FC<IpropsModalSettings> = ({ onClose, open }) => {
  const deviceDetector = new DeviceDetector();
  const {
    data: dataSession,
    isLoading: isLoadingSession,
    error: errorSession,
    isSuccess: isSuccessSession,
  } = useSessionsListQuery();
  const findIp = (ip: any) => {
    const newState = ip;
    const ipState = newState.split(".");
    ipState[1] = "xxx";
    ipState[2] = "xxx";
    return ipState.join(".");
  };

  const [
    mutateDeleteAll,
    {
      data: dataSessionDelAll,
      isLoading: isLoadingSessionDelAll,
      error: errorSessionDelAll,
      isSuccess: isSuccessSessionDelAll,
    },
  ] = useSessionsDeleteAllMutation();
  const [
    mutateDelete,
    {
      data: dataSessionDel,
      isLoading: isLoadingSessionDel,
      error: errorSessionDel,
      isSuccess: isSuccessSessionDel,
    },
  ] = useSessionsDeleteMutation();
  const submitPerSessionDelete = (id: any) => {
    mutateDelete(id);
  };
  const submitAllSessionDelete = () => {
    mutateDeleteAll("");
  };

  const locale = getUserLocale();
  const dateOptions: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  };
  
  return (
    <>
      <OverlayModalCommon onClose={onClose} open={open}>
        <div className="contentModalSettingsMapPc scrollbar-div">
          <div className="rowheaderModalSettingMap">
            <div onClick={onClose} className="icon3-close pointer" />
            <div className="titleheaderModal">نشست های فعال</div>
          </div>
          <div className="contentSessionList">
            <div className="rowItemCurrentSession">
              <div className="iconDeviceSessionContainer">
                <div className="icon3-android" />
              </div>
              <div className="detailCurrentSession">
                {dataSession?.sessions.slice(0, 1).map((session: any) => (
                  <>
                    <div className="titleNameDevice">
                      {session?.parsed_user_agent?.text === "" ? (
                        "دستگاه نا مشخص"
                      ) : (
                        <> {session?.parsed_user_agent?.text}</>
                      )}
                    </div>
                    <div className="rowLocationDeviceSession">
                      <span className="locationDeviceSession">ایران _ </span>
                      <div className="locationDeviceSession">
                        {findIp(session?.ip)}
                      </div>
                      <span className="statusActiveDeviceSession">
                        {" "}
                        {new Date(session?.last_accessed_at).toLocaleTimeString(
                          locale,
                          dateOptions
                        )}
                      </span>
                      <div
                        onClick={() => submitPerSessionDelete(session?.id)}
                        className="icon3-remove_done absDeleteSession"
                      />
                    </div>
                  </>
                ))}
              </div>
            </div>

            <div className="rowTitleOtherNameDevice">
              <div className="titleOtherNameDevice">دستگاه های دیگر</div>
            </div>
            <div className="rowItemCurrentSessionScroll scrollbar-div ">
              {dataSession?.sessions
                .slice(1)
                .map((session: any, index: number) => (
                  <div key={index} className="flexSession">
                    <div className="iconDeviceSessionContainer">
                      <div className="icon3-android" />
                    </div>

                    <div className="flexSessionDetail">
                      <div className="titleNameDevice">
                        {session?.parsed_user_agent?.text === "" ? (
                          "دستگاه نا مشخص"
                        ) : (
                          <> {session?.parsed_user_agent?.text}</>
                        )}
                      </div>
                      <div className="rowLocationDeviceSession">
                        <span className="locationDeviceSession">ایران _ </span>
                        <div className="locationDeviceSession">
                          {findIp(session?.ip)}
                        </div>
                        <span className="statusActiveDeviceSession">
                          {" "}
                          {new Date(
                            session?.last_accessed_at
                          ).toLocaleTimeString(locale, dateOptions)}
                        </span>
                      </div>
                    </div>
                    <div
                      onClick={() => submitPerSessionDelete(session?.id)}
                      className="icon3-remove_done absDeleteSession"
                    />
                  </div>
                ))}
            </div>
            <div
              onClick={submitAllSessionDelete}
              className="rowBottomInfoSessionsPc pointer"
            >
              <div className="icon3-remove_done" />
              <div className="bottomInfoSessions ">
                تمام دستگاه های دیگر را بیرون کنید
              </div>
            </div>
          </div>
        </div>
      </OverlayModalCommon>
    </>
  );
};
export default SessionModalPc;
